(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/button-how-to.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/button-how-to.js');

'use strict';

const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const ButtonHowTo = () => React.createElement(Button, {
  block: true,
  className: "btn btn-lotto with-icon",
  href: "/lotto/spelguide",
  type: "button"
}, "S\xE5 funkar Lotto", React.createElement("span", null, React.createElement(Icon, {
  icon: "information",
  size: "300"
})));
setGlobal('svs.lotto.react.components', {
  ButtonHowTo
});

 })(window);